export default {
      id: "ic-para-thumbdown-usage",
      viewBox: "0 0 26 26",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#ic-para-thumbdown-usage",
      toString: function () {
        return this.url;
      }
    }